const ModalTitle = ({ titleText }: { titleText: string }) => {
  // rendering modal header component here
  return (
    <h2 className='font-semibold text-legal-dark-blue text-2xl md:text-3xl capitalize italic'>
      {titleText}
    </h2>
  );
};

export default ModalTitle;
